import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  ActionButtonConfig,
  ButtonComponentConfig, ButtonSize, HeadingComponentConfig,
  IconComponentConfig, IconType, SelectableOption,
  SwitchComponentConfig, ButtonTitleBarView
} from '../../utils';
import { BreadcrumbOption } from '../../utils/breadcrumb/breadcrumb-option.interface';
import { DropdownMenuItem } from '../../utils/dropdown-menu/dropdown-menu-item.interface';
import { DropdownMenuComponentConfig } from '../../utils/dropdown-menu/dropdown-menu.interface';


@Component({
  selector: 'rappider-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class RappiderTitleBarComponent implements OnInit, OnChanges {

  @Input() mainTitle: HeadingComponentConfig;
  @Input() mainTitleButton: ButtonComponentConfig;
  @Input() options: BreadcrumbOption[];
  @Input() cssStyle: any;
  @Input() dropdownMenu: DropdownMenuComponentConfig;
  @Input() actionIcon: IconComponentConfig;
  @Input() actionButtons: ActionButtonConfig[];
  @Input() displayBreadcrumb = true;
  @Input() switchSettings: SwitchComponentConfig;
  @Input() radioButtonSettings: SelectableOption[];
  @Input() isSwitchVisible? = false;
  @Input() displayGripButton? = false;


  @Output() optionClick = new EventEmitter<BreadcrumbOption>();
  @Output() menuItemClick = new EventEmitter<DropdownMenuItem>();
  @Output() actionIconClick = new EventEmitter();
  @Output() actionButtonClick = new EventEmitter<ButtonComponentConfig>();
  @Output() actionButtonConfirm = new EventEmitter<ButtonComponentConfig>();
  @Output() radioButtonClick = new EventEmitter<string>();
  @Output() switchToggled = new EventEmitter<boolean>();
  @Output() gripButtonClicked = new EventEmitter<string>();
  @Output() doneClick = new EventEmitter();

  switchChecked: boolean;

  IconType = IconType;
  ButtonSize = ButtonSize;
  ButtonTitleBarView = ButtonTitleBarView;
  isDropdownVisible = false;

  ngOnInit() {
    if (this.switchSettings?.defaultValue) {
      this.switchChecked = !!this.switchSettings?.defaultValue;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.switchSettings) {
      this.switchChecked = !!this.switchSettings?.defaultValue;
    }
    if (changes?.actionButtons) {
      this.isDropdownVisible = this.actionButtons?.some(button => button.titleBarView === ButtonTitleBarView.Dropdown);
    }
  }

  onSwitchValueChanged(event) {
    this.switchChecked = !!event;
    this.switchToggled.emit(this.switchChecked);
  }


  onOptionClick(option: BreadcrumbOption) {
    this.optionClick.emit(option);
  }

  onMenuItemClick(menu: DropdownMenuItem) {
    this.menuItemClick.emit(menu);
  }

  onActionIconClick() {
    this.actionIconClick.emit();
  }

  onClickActionButton(button: ButtonComponentConfig) {
    this.actionButtonClick.emit(button);
  }

  onRadioButtonValueChange(radioValue) {
    this.radioButtonClick.emit(radioValue);
    console.log(event);
  }

  onGripButtonClick() {
    this.gripButtonClicked.emit(new Date().toISOString());
  }

  onJoyrideDoneButtonClick(){
    this.doneClick.emit();
  }

  onColumnActionClick(button: ButtonComponentConfig) {
    this.actionButtonClick.emit(button);
  }

  onColumnActionConfirm(button: ButtonComponentConfig) {
    this.actionButtonConfirm.emit(button);
  }
}
